<script>
    import axios from 'axios';
    import AppMixin from './../../../mixins/AppMixin';
    import AdaptersDialog from "../../../component/adapters/Dialog.vue";
    import {store} from "../store";
    import Button from "primevue/button";
    import Divider from "primevue/divider";
    import RadioButton from "primevue/radiobutton";
    import Checkbox from "primevue/checkbox";
    import {FormatHelper} from "../../../helpers/FormatHelper";
    import {UploadConstants} from "../../../constants/uploadConstants";

    export default {
        mixins: [AppMixin],
        data() {
            return {
                loading: false,
                maxSize: UploadConstants.MAX_UPLOAD_SIZE,
                allowExtensions: UploadConstants.ALLOW_IMPORT_FILE_EXTENSIONS,
                model: {targetNode: -2, format: 'txt', skipFirstLine: true, useKeysData: false},
                parsedLines: [],
                columnConfig: {},
                errorMsg: null,
                locale: window.locale,
                store: store,
            }
        },
        props: {
            name: {
                type: String,
                required: true
            },
            uid: {
                type: String,
                required: true
            },
            type: {
                type: String,
                required: true
            },
            isDemo: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        methods: {
            onClose() {
                this.list = null;
                this.errorMsg = null;
                this.parsedLines = [];
                this.columnConfig = {};
                this.$upload.reset(this.key);
            },
            onOpen() {
                if (this.type == 'import') {
                    this.model = {
                        targetNode: -1,
                        format: 'txt',
                        skipFirstLine: true,
                        useKeysData: false
                    };
                } else {
                    this.model = {
                        targetNode: -2,
                        format: 'txt',
                        skipFirstLine: true,
                        useKeysData: false
                    };
                }
            },
            csvToArray(text){
                let p = '', row = [''], ret = [row], i = 0, r = 0, s = !0, l;
                for (l of text) {
                    if ('"' === l) {
                        if (s && l === p) row[i] += l;
                        s = !s;
                    } else if (';' === l && s) l = row[++i] = '';
                    else if ('\n' === l && s) {
                        if ('\r' === p) row[i] = row[i].slice(0, -1);
                        row = ret[++r] = [l = '']; i = 0;
                    } else row[i] += l;
                    p = l;
                }
                return ret;
            },
            upload() {
                this.errorMsg = null;
                let result = {};

                if(this.model.format === 'csv'){
                    for (let column in this.columnConfig) {
                        if(this.columnConfig[column] !== "skip"){
                            result[this.columnConfig[column]] = column;
                        }
                    }

                    if(!Object.keys(result).length){
                        this.errorMsg = this.$t('lang.cluster.import_file_one_col_err');
                        return false;
                    }

                    if(!result.hasOwnProperty("word")){
                        this.errorMsg = this.$t('lang.cluster.import_file_col_err');
                        return false;
                    }

                }

                this.$upload.start(this.key);
            },
            onColumnConfigChange(event, index) {
                let value = event.target.value;

                for (let column in this.columnConfig) {
                    if(index != column && this.columnConfig[column] !== "skip" && this.columnConfig[column] === value){
                        this.columnConfig[column] = "skip";
                    }
                }

                this.columnConfig[index] = value;
            },
            onClickButtonAction() {
                this.$upload.reset(this.key);
                this.$upload.select(this.key);
            },
        },
        computed: {
            getSelectNode() {
                return this.store.getters.selectNode();
            },
            getApiUrl(){
                return this.$config.API_URL + '/clustering/' + this.uid + '/' +this.type + '/file' ;
            },
            error() {
                if (this.$upload.files(this.key).error.length) {
                    switch (this.$upload.files(this.key).error[0].error.code) {
                        case "file-max-size":
                            return this.$t('lang.cluster.file_size_err', [FormatHelper.number(this.maxSize)]);
                        case "file-extension":
                            return this.$t('lang.cluster.file_type_err', [this.allowExtensions.join(", ")]);
                        default:
                            return this.$upload.files(this.key).error[0].error.msg;
                    }
                }

                return null;
            },
            key(){
                return 'key_' + this.type;
            },
            btnModalLabel() {
                return this.type === 'import' ? this.$t('lang.main.btn.add') : this.$t('lang.main.btn.delete');
            },
            isCsv(){
                return this.parsedLines.length > 0 && this.model.format === 'csv';
            },
            isDisabledButtonAction() {
                return this.$upload.meta(this.key).state === 'sending' || this.$upload.meta(this.key).state === 'complete';
            },
            getLabelButtonAction() {
                switch (this.$upload.meta(this.key).state) {
                    case 'sending':
                        return this.$t('lang.main.btn.loading') + '...';
                    case 'ready':
                        return this.$t('lang.main.btn.choose') + '...';
                    case 'error':
                        return this.$t('lang.main.btn.choose') + '...';
                }
            },
        },

        created() {
            let self = this;
            this.$upload.on(this.key, {
                startOnSelect: false,
                extensions: self.allowExtensions,
                maxSizePerFile: self.maxSize,
                url: this.getApiUrl,
                http: (data) => {
                    data.body.append('targetNode', self.model.targetNode);
                    data.body.append('format', self.model.format);
                    data.body.append('skipFirstLine', self.model.skipFirstLine);
                    data.body.append('useKeysData', self.model.useKeysData);

                    let columnConfig = {};
                    for (let column in this.columnConfig) {
                        if(this.columnConfig[column] !== "skip"){
                            columnConfig[this.columnConfig[column]] = column;
                        }
                    }

                    data.body.append('columnConfig', JSON.stringify(columnConfig));

                    this.loading = true;
                    axios({
                        method: 'post',
                        url: data.url,
                        withCredentials: true,
                        data: data.body,
                    }).then(data.success, data.error)

                },
                parseErrors(res){
                    return [{code: 'fileError', msg: res.response.data.message}];
                },
                onSuccess(res) {
                    self.loading = false;
                    window.location.reload();
                },
                onError(error) {
                    self.loading = false;
                },
                onSelect(data) {
                    self.columnConfig = [];
                    self.parsedLines = [];
                    self.errorMsg = null;
                    let fileType = data[0].type;

                    if (fileType === "application/vnd.ms-excel" || fileType === "text/csv") {
                        self.model.format = "csv";
                    } else if (fileType === "text/plain") {
                        self.model.format = "txt";
                    }

                    if (self.model.format === 'txt') {
                        return false;
                    }

                    let reader = new FileReader();
                    reader.onload = function(evt) {
                        if (evt.target.readyState == FileReader.DONE) {
                            let result = decodeURIComponent(escape(window.atob(evt.target.result.split(",")[1])));
                            self.parsedLines = self.csvToArray(result).slice(0, 3);
                            if(self.parsedLines.length){
                                let i = 0;
                                let more = [];
                                self.parsedLines[0].forEach(line => {
                                    if(i === 0){
                                        self.columnConfig[i] = "word";
                                    }else{
                                        self.columnConfig[i] = "skip";
                                    }

                                    if (line.charCodeAt(0) === 0xFEFF) {
                                        line = line.substr(1);
                                    }

                                    if(line && line.toLowerCase() === self.$t('lang.cluster.cc_key')){
                                        self.columnConfig[i] = "word";
                                    }
                                    if(line && line.toLowerCase() === self.$t('lang.cluster.cc_ws')){
                                        self.columnConfig[i] = "ws";
                                    }
                                    if(line && line.toLowerCase() === self.$t('lang.cluster.cc_wsk')){
                                        self.columnConfig[i] = "wsk";
                                    }
                                    if(line && line.toLowerCase() === self.$t('lang.cluster.cc_superwsk')){
                                        self.columnConfig[i] = "superwsk";
                                    }

                                    i++;
                                    more.push("...")
                                });
                                self.parsedLines.push(more);
                            }
                        }
                    };

                    reader.readAsDataURL(data[0]);
                },
            });
        },
        components: {
            AdaptersDialog,
            Button,
            Divider,
            RadioButton,
            Checkbox,
        },
    }
</script>
<template>

    <AdaptersDialog
        :listener-id="name"
        :callback-on-show="onOpen"
        :callback-on-hide="onClose"
        :header="$t('lang.cluster.select_file')"
        :loading="loading"
        :error-message="errorMsg ?? error"
        :callback-agree="upload"
        :button-agree-label="btnModalLabel"
    >
        <template #content>
            <div>
                <p class="pb-0">{{$t('lang.cluster.txt_import_helper')}} <a :href="'/resources/' + locale + '/sample.txt'" target="_blank">{{$t('lang.cluster.select_file_example')}}</a></p>
                <p>{{$t('lang.cluster.csv_import_helper')}} <a :href="'/resources/' + locale + '/sample.csv?1'" target="_blank">{{$t('lang.cluster.select_file_example')}}</a></p>
            </div>
            <div class="ks-alert alert alert-info">
                <i aria-hidden="true" class="fa fa-info-circle"></i>&nbsp
                <span v-html="$t('lang.cluster.file_import_code')"></span>
            </div>
            <div class="mb-3">
                <Button
                    @click="onClickButtonAction"
                    :disabled="isDisabledButtonAction"
                    :label="getLabelButtonAction"
                    size="small"
                    class="mb-1"
                />
                <span class="info" style='text-align: left; display: block;' v-for="file in $upload.files(key).all">{{ file.name }}</span>
            </div>
            <Divider />
            <div class="formgroup-inline">
                <label>{{ $t('lang.cluster.select_folder') }}</label>
                <div v-if="type === 'delete'" class="field-radiobutton">
                    <RadioButton
                        v-model="model.targetNode"
                        inputId="f_deleted"
                        name="targetNode"
                        :value="-2"
                    />
                    <label for="f_deleted">{{ $t('lang.cluster.f_deleted') }}</label>
                </div>
                <div v-else-if="getSelectNode.id > 0" class="field-radiobutton">
                    <RadioButton
                        v-model="model.targetNode"
                        inputId="f_current"
                        name="targetNode"
                        :value="getSelectNode.id"
                    />
                    <label for="f_current">{{ $t('lang.cluster.f_current', [getSelectNode.name]) }}</label>
                </div>
                <div class="field-radiobutton">
                    <RadioButton
                        v-model="model.targetNode"
                        inputId="f_unallocated"
                        name="targetNode"
                        :value="-1"
                    />
                    <label for="f_unallocated">{{ $t('lang.cluster.f_unallocated') }}</label>
                </div>
            </div>
            <template v-if="isCsv">
                <Divider />
                <table>
                    <thead>
                        <tr>
                            <td v-for="(cell, index) in parsedLines[0]">
                                <select v-model="columnConfig[index]" @change="onColumnConfigChange($event, index)">
                                    <option value="word">{{$t('lang.cluster.vv_key')}}</option>
                                    <option value="ws">{{$t('lang.cluster.vv_ws')}}</option>
                                    <option value="wsk" v-if="isYandex">{{$t('lang.cluster.vv_wsk')}}</option>
                                    <option value="superwsk">{{$t('lang.cluster.vv_superwsk')}}</option>
                                    <option value="skip">{{$t('lang.cluster.vv_skip')}}</option>
                                </select>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="line in parsedLines">
                            <td v-for="cell in line">{{cell}}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="field-checkbox">
                    <Checkbox v-model="model.skipFirstLine" inputId="skipFirstLine" name="skipFirstLine" binary />
                    <label for="skipFirstLine">{{ $t('lang.cluster.skip_f_line') }}</label>
                </div>
                <div v-if="type === 'import' && !isDemo" class="field-checkbox">
                    <Checkbox v-model="model.useKeysData" inputId="useKeysData" name="useKeysData" binary />
                    <label for="useKeysData">
                        {{ $t('lang.cluster.use_our_data') }}
                        <i :title="$t('lang.cluster.use_our_data_help_' + reportEngine)" class="fa fa-question-circle" aria-hidden="true"></i>
                    </label>
                </div>
            </template>
        </template>
    </AdaptersDialog>
</template>
